import type { ChargeStatus } from '../../data/port.js';

/**
 * Centavos → "R$ 149,90".
 *
 * Divide só na exibição: o valor trafega inteiro do ERP até a baixa. Conta em
 * float com dinheiro quebra em casos banais (19,99 não é exato).
 */
export function formatBRL(cents: number): string {
  const sinal = cents < 0 ? '-' : '';
  const absoluto = Math.abs(cents);
  const reais = Math.trunc(absoluto / 100);
  const centavos = String(absoluto % 100).padStart(2, '0');
  const comMilhar = String(reais).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${sinal}R$ ${comMilhar},${centavos}`;
}

/** "5d antes" · "no vencimento" · "3d depois" */
export function descreverOffset(dias: number): string {
  if (dias === 0) return 'no vencimento';
  return dias < 0 ? `${Math.abs(dias)}d antes` : `${dias}d depois`;
}

/** ISO/datetime do backend → "20/07/2026" (ou o próprio valor se não bater). */
export function formatDate(iso: string | null): string | null {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
}

/** ISO → "20/07 14:32" para carimbos de falha. */
export function formatDateTime(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${m[3]}/${m[2]} ${m[4]}:${m[5]}`;
}

export type Tone = 'neutral' | 'ok' | 'info' | 'warn' | 'danger';

/** Cor semântica de cada status de cobrança para o badge. */
export function statusTone(status: ChargeStatus): Tone {
  switch (status) {
    case 'PAGO':
    case 'LIQUIDADO':
      return 'ok';
    case 'PENDENTE':
      return 'info';
    case 'EXPIRADO':
      return 'warn';
    case 'FALHOU':
      return 'danger';
  }
}

/** Iniciais para o avatar do operador. */
export function iniciais(nome: string): string {
  const partes = nome.trim().split(/[\s@._-]+/).filter(Boolean);
  if (partes.length === 0) return '?';
  if (partes.length === 1) return partes[0]!.slice(0, 2).toUpperCase();
  return (partes[0]![0]! + partes[partes.length - 1]![0]!).toUpperCase();
}

/** Papel → rótulo curto para o header. */
export function rotuloPapel(roles: readonly string[]): string {
  if (roles.includes('console-admin')) return 'Administrador';
  if (roles.includes('console-operador')) return 'Operador';
  if (roles.includes('console-leitura')) return 'Leitura';
  return 'Sem papel';
}
